import { setSafe } from "../../util/storeHelper";
import * as actions from "./actions";
/**
 * reducer for changes to ephemeral session state
 */
const sessionReducer = {
    reducers: {
        [actions.setAvailableExtensions]: (state, payload) => setSafe(state, ["available"], payload),
        [actions.setInstalledExtensions]: (state, payload) => setSafe(state, ["installed"], payload),
        [actions.setOptionalExtensions]: (state, payload) => setSafe(state, ["optional"], payload),
        [actions.setExtensionsUpdate]: (state, payload) => setSafe(state, ["updateTime"], payload),
    },
    defaults: {
        available: [],
        installed: {},
        optional: {},
        updateTime: 0,
    },
};
export default sessionReducer;
